import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { ImEye, ImEyeBlocked } from "react-icons/im";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const [epassword, setExistingPassword] = useState('');
  const [npassword, setNewPassword] = useState('');
  const [cpassword, setConfirmPassword] = useState('');

  const [showExistingPassword, setShowExistingPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setExistingPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!epassword) newErrors.epassword = 'Existing Password is required.';
    if (!npassword) newErrors.npassword = 'New Password is required.';
    if (!cpassword) newErrors.cpassword = 'Confirm Password is required.';

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    navigate("/");
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={8}>
          {/* Existing Password */}
          <div className="mb-3 position-relative">
            <Form.Floating>
              <Form.Control
                type={showExistingPassword ? 'text' : 'password'}
                placeholder="Existing Password"
                value={epassword}
                onChange={(e) => setExistingPassword(e.target.value)}
                className={errors.epassword ? 'is-invalid' : ''}
              />
              <label>Existing Password</label>
            </Form.Floating>
            <Button
              variant="outline-secondary"
              onClick={() => setShowExistingPassword(!showExistingPassword)}
              className="position-absolute top-50 translate-middle-y password-view-btn"
              style={{ border: 'none' }}
            >
              {showExistingPassword ? <ImEyeBlocked /> : <ImEye />}
            </Button>
            {errors.epassword && <div className="text-danger mt-1">{errors.epassword}</div>}
          </div>

          {/* New Password */}
          <div className="mb-3 position-relative">
            <Form.Floating>
              <Form.Control
                type={showNewPassword ? 'text' : 'password'}
                placeholder="New Password"
                value={npassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className={errors.npassword ? 'is-invalid' : ''}
              />
              <label>New Password</label>
            </Form.Floating>
            <Button
              variant="outline-secondary"
              onClick={() => setShowNewPassword(!showNewPassword)}
              className="position-absolute top-50 translate-middle-y password-view-btn"
              style={{ border: 'none' }}
            >
              {showNewPassword ? <ImEyeBlocked /> : <ImEye />}
            </Button>
            {errors.npassword && <div className="text-danger mt-1">{errors.npassword}</div>}
          </div>

          {/* Confirm Password */}
          <div className="mb-3 position-relative">
            <Form.Floating>
              <Form.Control
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder="Confirm Password"
                value={cpassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={errors.cpassword ? 'is-invalid' : ''}
              />
              <label>Confirm Password</label>
            </Form.Floating>
            <Button
              variant="outline-secondary"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className="position-absolute top-50 translate-middle-y password-view-btn"
              style={{ border: 'none' }}
            >
              {showConfirmPassword ? <ImEyeBlocked /> : <ImEye />}
            </Button>
            {errors.cpassword && <div className="text-danger mt-1">{errors.cpassword}</div>}
          </div>

          <div className="form-buttons">
            <Button type="submit" size="lg">Update Password</Button>
            <Button variant="link" onClick={resetForm}>Discard</Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default ChangePassword;
